import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "redux/types";
import { Response } from "services/types";
import { Customer } from "services/customer/types";
import { GetCustomersRequest } from "./types";
import { CustomerService } from "services/customer/customer.service";

/**
 * Load Customers by executing a remote API call.
 */
export const loadCustomers = createAsyncThunk<Response<Customer[]>, GetCustomersRequest, ThunkApiConfig>(
  "customers/load",
  async (request, thunkAPI) => {
    const service = new CustomerService();
    const response = await service.getCustomers();

    return response;
  }
);

